import type { ScheduledJob } from "@/features/scheduled-jobs/api/scheduled-jobs.api";
import { getScheduledJobHealthFilterKind } from "./scheduled-job-filters";

export interface ScheduledJobKpiStats {
  jobs: number;
  enabled: number;
  failing: number;
  overdue: number;
  inFlight: number;
}

/**
 * Strip totals for the filtered job list. Run-duration averages stay on the
 * chart series — the strip answers "how is the fleet?" not "how long did runs
 * take?".
 */
export function buildScheduledJobKpiStats(
  jobs: readonly ScheduledJob[],
  options: {
    now: number;
    overdueGraceMs?: number;
    unhealthyAfterFailures: number;
  },
): ScheduledJobKpiStats {
  let enabled = 0;
  let failing = 0;
  let overdue = 0;
  let inFlight = 0;

  for (const job of jobs) {
    if (job.state === "ENABLED") enabled += 1;

    const health = getScheduledJobHealthFilterKind(
      job,
      options.now,
      options.overdueGraceMs,
      options.unhealthyAfterFailures,
    );
    if (health === "failing") failing += 1;
    else if (health === "overdue") overdue += 1;

    for (const run of job.recentRuns) {
      if (run.status === "PENDING" || run.status === "PROCESSING") inFlight += 1;
    }
  }

  return {
    jobs: jobs.length,
    enabled,
    failing,
    overdue,
    inFlight,
  };
}
